/* [04] Field Camp: thermal printer animation. A vector [04] printer on screen prints the sheet digitally, then it prints for real.
   - receipt: when the order screen ("thanks") opens, the cart becomes a receipt (items, code, photo, QR) that slides out of the printer
   - postcard: when the selfie flow prints, the postcard slides out of the printer while the real print runs
   Auto print: ?kiosk=1 (or ?autoprint=1). Otherwise a Print button. */
(()=>{
if(window.__pr04)return;window.__pr04=1;
const $=s=>document.querySelector(s);
const P=new URLSearchParams(location.search);
/* touch screens that miss taps: photo buttons fire on first contact (pointerdown), the late click is ignored */
const FAST='#sfGo,#sfRetake,#sfPrint,#ppGo,#ppAgain,#ppUse,#ppSkip,#ppCont';
let fastT=0,fastSyn=false;
document.addEventListener('pointerdown',e=>{
  const b=e.target.closest&&e.target.closest(FAST);if(!b||b.disabled||b.offsetParent===null)return;
  if(Date.now()-fastT<700)return;
  e.preventDefault();fastT=Date.now();fastSyn=true;try{b.click()}finally{fastSyn=false}
},true);
document.addEventListener('click',e=>{
  if(fastSyn)return;const b=e.target.closest&&e.target.closest(FAST);
  if(b&&Date.now()-fastT<900){e.preventDefault();e.stopImmediatePropagation()}
},true);
const fastCss=document.createElement('style');
fastCss.textContent=`#sfGo,#sfRetake,#sfPrint,#ppGo,#ppAgain,#ppUse,#ppSkip,#ppCont{touch-action:manipulation;-webkit-tap-highlight-color:transparent;user-select:none;-webkit-user-select:none}
#sfGo,#ppGo,#sfPrint,#ppUse{min-height:88px!important;min-width:240px;padding:0 48px!important;font-size:17px!important}
#sfRetake,#ppAgain,#ppSkip,#ppCont{min-height:76px!important;min-width:160px;padding:0 36px!important;font-size:15px!important}`;
document.head.appendChild(fastCss);
const AUTO=P.get('kiosk')==='1'||P.get('autoprint')==='1';
const STORE='https://04-studios.com';
/* place of the stand (tours Europe): set once per totem with ?place=Milano&ll=45.4642,9.1900, remembered on this device */
const LOC=(()=>{let l={place:'Milano',lat:45.4642,lng:9.19};
  try{const k='fc04_loc',sv=JSON.parse(localStorage.getItem(k)||'null');if(sv&&sv.place)l=sv;
    const pl=P.get('place'),ll=(P.get('ll')||'').split(',').map(Number),okL=ll.length===2&&!isNaN(ll[0])&&!isNaN(ll[1]);
    if(pl||okL){if(pl)l.place=pl;if(okL){l.lat=ll[0];l.lng=ll[1]}localStorage.setItem(k,JSON.stringify(l))}
  }catch(e){}return l})();
const coord=(v,p,n)=>Math.abs(v).toFixed(4)+'° '+(v>=0?p:n);
const HG_URL=STORE+'/pages/hidden-garden?ref=fieldcamp&pts=20';
/* shared with the postcard: place, coordinates, "04" in Morse (0 = -----, 4 = ....-), Hidden Garden invite */
window.FC04_INFO=()=>({place:LOC.place.toUpperCase(),coords:coord(LOC.lat,'N','S')+'  '+coord(LOC.lng,'E','W'),morse:'–––––   ••••–',hg:HG_URL,
  hgLine:lang()==='en'?'You got 20 Hidden Garden points.':'Hai ottenuto 20 punti Hidden Garden.',hgSub:lang()==='en'?'Scan to join':'Scansiona e iscriviti'});
const lang=()=>(document.documentElement.lang==='en'?'en':'it');
const TX={
 it:{receipt:'Scontrino',card:'Cartolina',printing:'Sto stampando',ready:'Strappa lo scontrino.',readyC:'Prendi la tua cartolina.',print:'Stampa di nuovo',done:'Fine',order:'ORDINE',total:'TOTALE',thanks:'Grazie. Ci vediamo a Field Camp.',ship:'Spedizione a casa',pickup:'Ritiro allo stand',stand:'Paga alla cassa e ritira subito',pcs:'pz'},
 en:{receipt:'Receipt',card:'Postcard',printing:'Printing',ready:'Tear off your receipt.',readyC:'Take your postcard.',print:'Print again',done:'Done',order:'ORDER',total:'TOTAL',thanks:'Thank you. See you at Field Camp.',ship:'Shipped home',pickup:'Pick up at the stand',stand:'Pay at the till and take it now',pcs:'pcs'}
};
const T=()=>TX[lang()];
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const eur=n=>n.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g,'.')+' €';

const RC_CSS=`.rc{font-family:"Inter Tight",Arial,Helvetica,sans-serif;color:#000;background:#fff;padding:12px 10px 14px;width:100%;box-sizing:border-box;font-size:10.5px;line-height:1.35;-webkit-print-color-adjust:exact;print-color-adjust:exact}
.rc .hd{display:flex;justify-content:space-between;align-items:flex-end;gap:8px;padding-bottom:8px;border-bottom:2px solid #000}
.rc h1{font-size:19px;letter-spacing:-.045em;margin:0;line-height:.9;font-weight:700}
.rc h1 sup{font-size:.42em;letter-spacing:0;vertical-align:top;position:relative;top:.1em}
.rc .ev{font-size:8px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;text-align:right;line-height:1.25}
.rc .kv{display:grid;grid-template-columns:auto 1fr;gap:2px 10px;margin:8px 0 0;font-size:9px}
.rc .kv dt{font-weight:700;letter-spacing:.08em;text-transform:uppercase}
.rc .kv dd{margin:0;text-align:right;font-variant-numeric:tabular-nums}
.rc .m{font-size:8px;letter-spacing:.1em;text-transform:uppercase}
.rc hr{border:0;border-top:1px dashed #000;margin:9px 0}
.rc .code{display:flex;justify-content:space-between;align-items:baseline;font-size:9px;letter-spacing:.08em;text-transform:uppercase}
.rc .code b{font-size:12px;letter-spacing:.04em}
.rc .r{display:grid;grid-template-columns:1fr auto;gap:8px;margin:3px 0}
.rc .r small{display:block;font-size:8px;letter-spacing:.08em;text-transform:uppercase}
.rc .r span:last-child{font-variant-numeric:tabular-nums}
.rc .tot{display:flex;justify-content:space-between;font-weight:700;font-size:13px;border-top:2px solid #000;margin-top:8px;padding-top:6px}
.rc .phw{margin:10px 0 0}
.rc img.ph{width:100%;aspect-ratio:1;object-fit:cover;display:block;filter:grayscale(1) contrast(1.2)}
.rc .phc{font-size:8px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;margin-top:4px;display:flex;justify-content:space-between}
.rc .hgb{display:grid;grid-template-columns:52px 1fr;gap:9px;align-items:center;border:1px solid #000;padding:7px}
.rc .qr svg{width:52px;height:52px;display:block}
.rc .hgb b{display:block;font-size:10px;line-height:1.2}
.rc .hgb span{display:block;font-size:8px;letter-spacing:.08em;text-transform:uppercase;margin-top:3px}
.rc .ft{text-align:center;margin-top:10px}
.rc .mo{font-weight:700;font-size:10px;letter-spacing:.3em}
.rc .ty{font-size:9.5px;margin-top:4px}`;

/* ---------- state kept for this customer's session only, in memory ---------- */
let PHOTO=null; /* receipt photo, taken before payment, wiped when the session ends */

/* ---------- overlay ---------- */
const css=document.createElement('style');
css.textContent=`
#pr{position:fixed;inset:0;z-index:60;background:#edebe7;color:#030302;display:grid;grid-template-rows:auto 1fr auto;isolation:isolate;overflow:hidden;font-family:var(--f-ui,"Inter Tight",Archivo,Helvetica,Arial,sans-serif)}
#pr[hidden]{display:none!important}
#pr .pr-top{height:72px;padding:0 20px;display:flex;align-items:center;gap:14px;border-bottom:1px solid #d9d6cf;background:#fff}
#pr .pr-logo{font-weight:700;font-size:24px;letter-spacing:-.04em;line-height:1}
#pr .pr-logo sup{font-size:.42em;letter-spacing:0;margin-left:1px;vertical-align:top;position:relative;top:.1em}
#pr .pr-ttl{margin-left:auto;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#61703a}
#pr .pr-mid{display:grid;justify-items:center;align-content:end;padding:12px 16px 0;overflow:hidden}
#pr .pr-stage{position:relative;width:min(86vw,400px);aspect-ratio:320/150}
#pr .pr-stage svg{position:absolute;inset:0;width:100%;height:100%;z-index:2;filter:drop-shadow(0 12px 18px rgba(3,3,2,.22))}
#pr .pr-paper{position:absolute;left:11.9%;width:76.25%;bottom:73.3%;height:min(64vh,680px);overflow:hidden;z-index:1}
#pr .pr-sheet{position:absolute;left:0;right:0;bottom:0;transform:translateY(102%);will-change:transform;filter:drop-shadow(0 6px 12px rgba(3,3,2,.18))}
#pr .pr-sheet .zz{padding-bottom:34px}
#pr .pr-sheet .zz::before{content:'';display:block;height:7px;margin-bottom:-1px;background:linear-gradient(315deg,#fff 25%,transparent 25%) -6px 0,linear-gradient(45deg,#fff 25%,transparent 25%) -6px 0;background-size:12px 12px}
#pr .pr-sheet img.pc{display:block;width:100%;border:8px solid #fff;box-sizing:border-box;background:#fff}
#pr .pr-bot{padding:16px 20px calc(20px + env(safe-area-inset-bottom,0px));display:grid;gap:12px;justify-items:center;background:linear-gradient(0deg,#edebe7 55%,rgba(237,235,231,0))}
#pr .pr-msg{font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;min-height:16px}
#pr .pr-btns{display:flex;gap:10px;flex-wrap:wrap;justify-content:center;min-height:60px}
#pr .pr-btn{min-height:60px;padding:0 30px;border-radius:999px;border:1px solid #030302;background:#fff;color:#030302;font:700 13px/1 inherit;font-family:inherit;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}
#pr .pr-btn.pri{background:#030302;color:#fff}
#pr .pr-btn[hidden]{display:none}
#pr svg .led{animation:prled .7s steps(2) infinite}
@keyframes prled{50%{opacity:.25}}
@media(max-width:599px){#pr .pr-top{height:60px;padding:0 12px}#pr .pr-logo{font-size:18px}}
`+RC_CSS;
document.head.appendChild(css);

const root=document.createElement('div');root.id='pr';root.hidden=true;root.setAttribute('role','dialog');
root.innerHTML=`<div class="pr-top"><div class="pr-logo">[04]-STUDIOS<sup>™</sup></div><span class="pr-ttl" id="prTtl"></span></div>
<div class="pr-mid"><div class="pr-stage" id="prStage">
<svg viewBox="0 0 320 150" aria-hidden="true">
 <rect x="8" y="136" width="304" height="12" rx="6" fill="#1d1d1b"/>
 <rect x="4" y="22" width="312" height="118" rx="24" fill="#030302"/>
 <rect x="14" y="26" width="292" height="3" rx="1.5" fill="#fff" opacity=".12"/>
 <rect x="30" y="34" width="260" height="12" rx="6" fill="#000"/>
 <rect x="34" y="36" width="252" height="2" rx="1" fill="#fff" opacity=".1"/>
 <rect x="26" y="62" width="268" height="30" rx="15" fill="#1d1d1b"/>
 <text x="44" y="82" font-family="Arial,Helvetica,sans-serif" font-size="13" font-weight="700" letter-spacing="2" fill="#808D45" id="prLcd">PRINTING</text>
 <circle class="led" cx="276" cy="77" r="5" fill="#808D45"/>
 <text x="26" y="126" font-family="Arial,Helvetica,sans-serif" font-size="22" font-weight="700" letter-spacing="-1" fill="#fff">[04]</text>
 <rect x="196" y="112" width="98" height="8" rx="4" fill="#1d1d1b"/><rect x="196" y="112" width="34" height="8" rx="4" fill="#808D45"/>
</svg>
<div class="pr-paper"><div class="pr-sheet" id="prSheet"></div></div></div></div>
<div class="pr-bot"><div class="pr-msg" id="prMsg"></div><div class="pr-btns"><button class="pr-btn pri" id="prPrint" hidden></button><button class="pr-btn" id="prDone" hidden></button></div></div>`;
document.body.appendChild(root);

/* ---------- receipt ---------- */
function qrSvg(url){
  try{if(window.qrcode){const q=qrcode(0,'M');q.addData(url,'Byte');q.make();return q.createSvgTag({cellSize:3,margin:0,scalable:true})}}catch(e){}
  return '';
}
function fulfil(a){
  const x=T(),f=(a&&a.fulfilment)||'';
  return f==='ritiro-popup'?x.pickup:f==='spedizione'?x.ship:x.stand;
}
function rcBody(d,screen){
  const x=T();
  const rows=d.items.map(i=>`<div class="r"><span>${esc(i.t)}<small>${i.s?esc(i.s)+' · ':''}×${i.q}</small></span><span>${eur(i.p)}</span></div>`).join('');
  const I=window.FC04_INFO(),now=new Date(),pad=n=>String(n).padStart(2,'0');
  const L=lang()==='en'?{d:'Date',t:'Time',p:'Place',c:'Coord.',seen:'Seen at Field Camp'}:{d:'Data',t:'Ora',p:'Luogo',c:'Coord.',seen:'Visto a Field Camp'};
  return `<div class="rc${screen?' zz':''}">
<div class="hd"><h1>[04]-STUDIOS<sup>™</sup></h1><div class="ev">Field Camp<br>${esc(I.place)}</div></div>
<dl class="kv"><dt>${L.d}</dt><dd>${pad(now.getDate())}.${pad(now.getMonth()+1)}.${now.getFullYear()}</dd><dt>${L.t}</dt><dd>${pad(now.getHours())}:${pad(now.getMinutes())}</dd><dt>${L.p}</dt><dd>${esc(I.place)}</dd><dt>${L.c}</dt><dd>${I.coords}</dd></dl>
<hr><div class="code"><span>${x.order}</span><b>${esc(d.code)}</b></div><div class="m" style="margin-top:2px">${esc(d.how)}</div><hr>
${rows}<div class="tot"><span>${x.total}</span><span>${eur(d.total)}</span></div>
${d.photo?`<div class="phw"><img class="ph" alt="" src="${d.photo}"><div class="phc"><span>${L.seen}</span><span>${pad(now.getHours())}:${pad(now.getMinutes())}</span></div></div>`:''}
<hr><div class="hgb"><div class="qr">${qrSvg(I.hg)}</div><div><b>${I.hgLine}</b><span>${I.hgSub} · Hidden Garden</span></div></div>
<div class="ft"><div class="mo">${I.morse}</div><div class="m" style="margin-top:4px">04-STUDIOS.COM</div><div class="ty">${x.thanks}</div></div></div>`;
}
async function readCart(){
  try{
    const r=await fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});if(!r.ok)return null;
    const c=await r.json();if(!c||!c.items||!c.items.length)return null;
    const a=c.attributes||{};
    return{code:a.kiosk_code||'04-----',how:fulfil(a),total:(c.total_price||0)/100,photo:PHOTO,
      items:c.items.map(i=>({t:i.product_title,s:(i.variant_title&&i.variant_title!=='Default Title')?i.variant_title:'',q:i.quantity,p:(i.final_line_price||i.line_price||0)/100}))};
  }catch(e){return null}
}
/* the print iframe does not inherit the theme fonts: copy the Suisse @font-face rules into it */
function fontFaces(){
  let out='';
  for(const sh of Array.from(document.styleSheets)){
    let rules;try{rules=sh.cssRules}catch(e){continue}
    for(const r of Array.from(rules||[])){
      if(r.type===5&&/suisse/i.test(r.cssText)){
        const base=sh.href||location.href;
        out+=r.cssText.replace(/url\((['"]?)([^'")]+)\1\)/g,(m,q,u)=>{try{return 'url("'+new URL(u,base).href+'")'}catch(e){return m}})+'\n';
      }
    }
  }
  return out;
}
function printDoc(d){
  const body=rcBody(d,false);
  const html='<!doctype html><html><head><meta charset="utf-8"><title>04</title><style>'+fontFaces()+'@page{size:80mm auto;margin:0}html,body{margin:0;background:#fff}.w{width:72mm;margin:0 auto}'+RC_CSS+'</style></head><body><div class="w">'+body+'</div></body></html>';
  const f=document.createElement('iframe');f.setAttribute('aria-hidden','true');
  f.style.cssText='position:fixed;left:-9999px;top:0;width:80mm;height:200mm;border:0;opacity:0';
  document.body.appendChild(f);
  const go=()=>{try{f.contentWindow.focus();f.contentWindow.print()}catch(e){}setTimeout(()=>f.remove(),9000)};
  f.onload=()=>{let done=false;const once=()=>{if(!done){done=true;setTimeout(go,150)}};
    try{const fd=f.contentDocument.fonts;fd.load("700 14px 'Suisse Int\'l'").catch(()=>{});fd.ready.then(once,once)}catch(e){once()}
    setTimeout(once,2500)};
  f.srcdoc=html;
}

/* ---------- animation ---------- */
let timers=[],raf=0,mossL=null,mossRaf=0,printed=false,curData=null;
const later=(fn,ms)=>{const id=setTimeout(fn,ms);timers.push(id);return id};
function mossBg(){
  const e=window.Moss04Engine;if(!e)return;
  try{
    if(mossL){mossL.cv.remove();mossL=null}
    e.setSeed(1+Math.floor(Math.random()*9999));
    mossL=new e.Layer(root,{lut:e.makeLUT(e.DEF),size:1.2,dir:'up',anchor:'bottom',profile:x=>e.ss(.55,1,x)});
    mossL.build();
    /* light and gradual: low reach, soft fade towards the top, no solid block */
    const cv=mossL.cv;if(cv){cv.style.opacity='.6';cv.style.webkitMaskImage=cv.style.maskImage='linear-gradient(0deg,#000 0%,rgba(0,0,0,.55) 30%,transparent 62%)'}
    const t0=performance.now(),edge=x=>x<=0?0:.25+1.05*x;
    const st=now=>{const p=Math.min(1,(now-t0)/4200),q=p*p*(3-2*p);mossL.paint(q*.5,edge(q*.5));if(p<1)mossRaf=requestAnimationFrame(st)};
    mossRaf=requestAnimationFrame(st);
  }catch(err){}
}
function closeP(){
  timers.forEach(clearTimeout);timers=[];cancelAnimationFrame(raf);cancelAnimationFrame(mossRaf);
  root.hidden=true;if(mossL){try{mossL.cv.remove()}catch(e){}mossL=null}
  $('#prSheet').innerHTML='';curData=null;
}
function feed(dur,done){
  const sh=$('#prSheet'),stage=$('#prStage'),t0=performance.now(),steps=Math.max(14,Math.round(dur/190));
  const tick=now=>{
    const p=Math.min(1,(now-t0)/dur);
    const sp=Math.floor(p*steps)/steps; /* stepped, like paper being fed line by line */
    sh.style.transform='translateY('+((1-sp)*102)+'%)';
    stage.style.transform=p<1?'translateX('+((Math.floor(now/60)%2?.7:-.7))+'px)':'none';
    if(p<1)raf=requestAnimationFrame(tick);else{sh.style.transform='translateY(0)';done()}
  };
  raf=requestAnimationFrame(tick);
}
function openP(kind){
  const x=T();timers.forEach(clearTimeout);timers=[];cancelAnimationFrame(raf);
  root.hidden=false;printed=false;
  $('#prTtl').textContent=kind==='card'?x.card:x.receipt;
  $('#prMsg').textContent=x.printing+'…';$('#prLcd').textContent=x.printing.toUpperCase();
  $('#prPrint').hidden=true;$('#prDone').hidden=true;
  $('#prPrint').textContent=x.print;$('#prDone').textContent=x.done;
  $('#prSheet').style.transform='translateY(102%)';
  mossBg();
}
function playReceipt(d){
  curData=d;openP('receipt');
  $('#prSheet').innerHTML=rcBody(d,true);
  const dur=Math.min(8000,3600+d.items.length*600);
  feed(dur,()=>{
    $('#prMsg').textContent=T().ready;$('#prLcd').textContent=T().ready.toUpperCase().replace('.','');
    $('#prPrint').hidden=false;$('#prDone').hidden=false;
    if(AUTO&&!printed){printed=true;later(()=>printDoc(d),500)}
    later(closeP,45000);
  });
}
function playCard(img){
  openP('card');
  $('#prSheet').innerHTML='<img class="pc" alt="" src="'+img+'">';
  feed(5200,()=>{
    $('#prMsg').textContent=T().readyC;$('#prLcd').textContent='OK';
    later(closeP,4500);
  });
}
$('#prPrint').onclick=()=>{if(curData)printDoc(curData)};
$('#prDone').onclick=()=>{closeP();const b=$('#thDone');if(b)b.click()};

/* ---------- photo step before payment ---------- */
const PX={
 it:{ttl:'Foto per lo scontrino',h:'Una foto per il tuo scontrino.',p:'La facciamo prima del pagamento. Quando l’ordine è pagato, lo scontrino esce con la tua foto. Resta solo su questo schermo e sullo scontrino, poi viene cancellata.',go:'Scatta',skip:'Senza foto',use:'Usa questa foto',again:'Rifai',err:'La fotocamera non è disponibile.',cont:'Continua senza foto'},
 en:{ttl:'Receipt photo',h:'A photo for your receipt.',p:'We take it before payment. Once your order is paid, the receipt comes out with your photo. It stays only on this screen and on the receipt, then it is deleted.',go:'Take photo',skip:'No photo',use:'Use this photo',again:'Retake',err:'The camera is not available.',cont:'Continue without photo'}
};
const PT=()=>PX[lang()];
let PH_OK=false,stream=null,ppIdle=0,tmpPhoto=null;
const ppCss=document.createElement('style');
ppCss.textContent=`
#pp{position:fixed;inset:0;z-index:58;background:#fff;color:#030302;display:grid;grid-template-rows:auto 1fr;font-family:var(--f-ui,"Inter Tight",Archivo,Helvetica,Arial,sans-serif)}
#pp[hidden]{display:none!important}
#pp .pp-top{height:72px;padding:0 20px;display:flex;align-items:center;gap:14px;border-bottom:1px solid #d9d6cf}
#pp .pp-logo{font-weight:700;font-size:24px;letter-spacing:-.04em;line-height:1}
#pp .pp-logo sup{font-size:.42em;letter-spacing:0;margin-left:1px;vertical-align:top;position:relative;top:.1em}
#pp .pp-ttl{margin-left:auto;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#61703a}
#pp .pp-main{display:grid;place-items:center;padding:16px;overflow:hidden}
#pp .pp-v{display:grid;gap:18px;justify-items:center;width:100%}
#pp .pp-v[hidden]{display:none!important}
#pp .pp-card{padding:clamp(24px,4vw,44px);width:min(620px,100%);display:grid;gap:20px;justify-items:start;border:1px solid #d9d6cf}
#pp .pp-card h2{font-weight:700;font-size:clamp(34px,6vw,60px);letter-spacing:-.04em;line-height:.98;text-wrap:balance}
#pp .pp-card p{font-size:clamp(16px,1.8vw,19px);max-width:46ch}
#pp .pp-btns{display:flex;gap:10px;flex-wrap:wrap;justify-content:center}
#pp .pp-btn{min-height:60px;padding:0 30px;border-radius:999px;border:1px solid #030302;background:#fff;color:#030302;font:700 13px/1 inherit;font-family:inherit;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}
#pp .pp-btn.pri{background:#030302;color:#fff}
#pp .pp-frame{position:relative;width:min(88vw,calc((100vh - 260px)*.75),480px);aspect-ratio:3/4;background:#edebe7;overflow:hidden;border:1px solid #d9d6cf}
#pp .pp-frame video,#pp .pp-frame img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}
#pp .pp-frame video{transform:scaleX(-1)}
#pp .pp-cd{position:absolute;inset:0;display:grid;place-items:center;font-size:clamp(120px,30vw,240px);font-weight:700;color:#fff;text-shadow:0 2px 24px rgba(3,3,2,.4)}
#pp .pp-flash{position:absolute;inset:0;background:#fff;opacity:0;pointer-events:none}
#pp .pp-flash.on{animation:ppf .45s ease-out}
@keyframes ppf{0%{opacity:.95}100%{opacity:0}}
@media(max-width:599px){#pp .pp-top{height:60px;padding:0 12px}#pp .pp-logo{font-size:18px}}
`;
document.head.appendChild(ppCss);
const pp=document.createElement('div');pp.id='pp';pp.hidden=true;pp.setAttribute('role','dialog');
pp.innerHTML=`<div class="pp-top"><div class="pp-logo">[04]-STUDIOS<sup>™</sup></div><span class="pp-ttl" id="ppTtl"></span></div>
<div class="pp-main">
 <div class="pp-v" id="ppIntro"><div class="pp-card"><h2 id="ppH"></h2><p id="ppP"></p><div class="pp-btns"><button class="pp-btn pri" id="ppGo"></button><button class="pp-btn" id="ppSkip"></button></div></div></div>
 <div class="pp-v" id="ppCam" hidden><div class="pp-frame"><video id="ppVid" playsinline muted autoplay></video><div class="pp-cd" id="ppCd"></div><div class="pp-flash" id="ppFl"></div></div></div>
 <div class="pp-v" id="ppRev" hidden><div class="pp-frame"><img id="ppImg" alt=""></div><div class="pp-btns"><button class="pp-btn pri" id="ppUse"></button><button class="pp-btn" id="ppAgain"></button></div></div>
 <div class="pp-v" id="ppErr" hidden><div class="pp-card"><h2 id="ppEh"></h2><div class="pp-btns"><button class="pp-btn pri" id="ppCont"></button></div></div></div>
</div>`;
document.body.appendChild(pp);
const ppView=v=>['Intro','Cam','Rev','Err'].forEach(n=>{$('#pp'+n).hidden=n!==v});
function ppStop(){if(stream){stream.getTracks().forEach(x=>x.stop());stream=null}const v=$('#ppVid');if(v)v.srcObject=null}
function ppClose(){ppStop();clearTimeout(ppIdle);tmpPhoto=null;pp.hidden=true;$('#ppImg').removeAttribute('src')}
function ppArm(){clearTimeout(ppIdle);ppIdle=setTimeout(ppClose,50000)}
function ppLabels(){const x=PT();$('#ppTtl').textContent=x.ttl;$('#ppH').textContent=x.h;$('#ppP').textContent=x.p;$('#ppGo').textContent=x.go;$('#ppSkip').textContent=x.skip;$('#ppUse').textContent=x.use;$('#ppAgain').textContent=x.again;$('#ppEh').textContent=x.err;$('#ppCont').textContent=x.cont}
function ppOpen(){PHOTO=null;ppLabels();pp.hidden=false;ppView('Intro');ppArm()}
function ppDone(withPhoto){
  PHOTO=withPhoto?tmpPhoto:null;PH_OK=true;ppClose();
  const b=document.getElementById('toPay');if(b)b.click();
}
async function ppCam(){
  ppView('Cam');ppArm();$('#ppCd').textContent='';
  try{
    stream=await navigator.mediaDevices.getUserMedia({video:{facingMode:'user',width:{ideal:1280},height:{ideal:960}},audio:false});
    const v=$('#ppVid');v.srcObject=stream;await v.play().catch(()=>{});
    let n=3;$('#ppCd').textContent=n;
    const tick=()=>{n--;if(n>0){$('#ppCd').textContent=n;ppIdle=setTimeout(tick,900)}else{$('#ppCd').textContent='';ppSnap()}};
    ppIdle=setTimeout(tick,900);
  }catch(e){ppStop();ppView('Err')}
}
function ppSnap(){
  const v=$('#ppVid'),W=600,H=800,c=document.createElement('canvas');c.width=W;c.height=H;
  const vw=v.videoWidth||640,vh=v.videoHeight||480,k=Math.max(W/vw,H/vh),w=vw*k,h=vh*k,g=c.getContext('2d');
  g.translate(W,0);g.scale(-1,1);g.drawImage(v,(W-w)/2,(H-h)/2,w,h);
  $('#ppFl').classList.remove('on');void $('#ppFl').offsetWidth;$('#ppFl').classList.add('on');
  tmpPhoto=c.toDataURL('image/jpeg',.82);ppStop();
  setTimeout(()=>{$('#ppImg').src=tmpPhoto;ppView('Rev');ppArm()},350);
}
$('#ppGo').onclick=ppCam;$('#ppAgain').onclick=ppCam;
$('#ppSkip').onclick=()=>ppDone(false);$('#ppCont').onclick=()=>ppDone(false);$('#ppUse').onclick=()=>ppDone(true);
new MutationObserver(()=>{if(document.documentElement.lang)ppLabels()}).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
/* "Procedi al pagamento" first goes through the photo step, once per order */
document.addEventListener('click',e=>{
  const b=e.target.closest&&e.target.closest('#toPay');if(!b||b.disabled)return;
  if(PH_OK||PHOTO)return;
  e.preventDefault();e.stopImmediatePropagation();ppOpen();
},true);

/* ---------- hooks into the kiosk (no changes to its own files) ---------- */
const th=$('#s-thanks'),att=$('#s-attract');
if(th)new MutationObserver(()=>{
  if(th.hidden)return;
  readCart().then(d=>{if(d&&!th.hidden)playReceipt(d)});
}).observe(th,{attributes:true,attributeFilter:['hidden']});
if(att)new MutationObserver(()=>{if(!att.hidden){closeP();ppClose();PHOTO=null;PH_OK=false}}).observe(att,{attributes:true,attributeFilter:['hidden']});
/* selfie print: grab the composed postcard when Print is tapped, show it coming out of the printer */
document.addEventListener('click',e=>{
  if(!e.target.closest||!e.target.closest('#sfPrint'))return;
  try{const c=$('#sfPrev');if(c&&c.width>10){playCard(c.toDataURL('image/jpeg',.88))}}catch(err){}
},true);
})();

